import { Box } from '@mui/material';
import { StartFreeSection as StartFree } from '@/components';
import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';

type StartFreeSectionProps = {
  ns: string;
};

export const StartFreeSection: FC<StartFreeSectionProps> = ({ ns }) => {
  const { t } = useTranslation(ns);
  return (
    <Box component="section">
      <StartFree
        title={<Trans ns={ns} i18nKey="startFree.title" components={{ br: <br /> }} />}
        subtitle={t('startFree.subtitle')}
      />
    </Box>
  );
};
